"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImpactResult = void 0;
var components_1 = require("../../components");
exports.ImpactResult = {
  name: 'ImpactResult',
  label: 'Impact Result',
  pluralLabel: 'Impact Results',
  update: {
    queryFields: "\n      type { id slug name }\n      direction\n      description { id text }\n    "
  },
  table: {
    fieldNames: ["description", "type", "direction"],
    options: {
      direction: {
        component: components_1.ImpactResultDirectionCell
      }
    }
  },
  form: {
    bufferAtEnd: 200,
    modal: {
      maxWidth: "800px"
    },
    fields: {
      id: {
        type: 'id'
      },
      type: {
        type: 'linked',
        entityTypeName: 'ImpactResultType',
        description: 'What type of {{IMPACT_RESULT}} is described?'
      },
      description: {
        type: 'description',
        required: true
      },
      title: {
        type: 'text',
        description: 'Enter a title for this {{IMPACT_RESULT}} (displayed in bold before the Description)'
      },
      direction: {
        type: 'select',
        maxWidth: '300px',
        description: 'Select a direction to show with alongside this result. For example \'Increase\' might indicate extra profit, or \'Decrease\' might indicate a reduction in the number of injuries',
        options: [{
          label: "Increase",
          value: "Increase"
        }, {
          label: "Decrease",
          value: "Decrease"
        }]
      }
    }
  }
};